import amplitude from 'amplitude-js'
import { isError } from 'lodash'
import moment from 'moment'
import { routes } from '../router'
import { getTermsAndConditions, getUserInfo, isLoggedIn, logoutUser } from '../services/UserService'
import store from '../store'
import { userPrimaryRoles } from '../utils/constants'
import { getSubdomain, removeSubdomainAndRedirect } from '../utils/url'

const routeChangeEvent = (to, from, redirect) => {
  const eventParameters = {
    from: from.meta.pageName,
    to: to.meta.pageName,
    redirect,
    publicPage: !to.meta.isPrivate
  }
  amplitude.getInstance().logEvent('Page access', eventParameters)
}

const getLoggedRoute = async (to, from, next) => {
  if (!store.state.userInfo.userInfo) {
    await store.dispatch('getLoggedUserInfo')
    store.dispatch('userIsLoggedIn')
  }
  const userInfo = store.state.userInfo.userInfo
  const isTrial = userInfo.primaryRoles.find(role => role.name === userPrimaryRoles.trial)
  const remainingDays = 15 - moment().diff(userInfo.joinDate, 'days')
  if (isTrial && remainingDays <= 0 && to.name !== routes.trialFinished && to.name !== routes.license) {
    routeChangeEvent(to, from, routes.trialFinished)
    next({ name: routes.trialFinished })
  } else if ((!isTrial && to.name === routes.trialFinished) ||
    (isTrial && remainingDays > 0 && to.name === routes.trialFinished) ||
    (to.name === routes.home)) {
    routeChangeEvent(to, from, routes.feed)
    next({ name: routes.feed })
  } else {
    routeChangeEvent(to, from)
    next()
  }
  if (to.fullPath.includes('krea')) {
    const { activeKreaLicense } = userInfo
    if (!activeKreaLicense) {
      next({ name: routes.home })
    }
    const { data } = await getTermsAndConditions()
    if (data.signedTermsAndCondition) next()
    else next({ name: routes.signTerms })
  }
}

export const beforeEachRoute = async (to, from, next) => {
  const hasToken = isLoggedIn()
  const logged = store.state.userInfo.userLoggedIn
  const subdomain = getSubdomain()

  if (!to.name) {
    routeChangeEvent(to, from, routes.notFound)
    return next({ name: routes.notFound })
  }

  if (subdomain && !store.state.whiteLabel.hasSubdomain) {
    store.dispatch('setHasSubdomain', true)
    await store.dispatch('getSubdomainInfo', getSubdomain())
  }

  if (to.meta.isPrivate || (!to.meta.isPrivate && to.meta.allowSession)) {
    if (!to.meta.isPrivate && to.meta.allowSession) return next()
    if (logged) return getLoggedRoute(to, from, next)
    else if (!logged && !hasToken) {
      store.commit('setRedirectPath', to.fullPath)
      routeChangeEvent(to, from, routes.login)
      return subdomain && to.meta.isLanding ? next({ name: routes.corporativeLogin }) : next({ name: routes.login })
    } else if (hasToken) {
      const response = await getUserInfo().catch(e => e.response)
      const success = !isError(response.status)
      if (success) return getLoggedRoute(to, from, next)
      else {
        logoutUser()
        to.name === routes.notFound
          ? store.commit('setRedirectPath', '/feed')
          : store.commit('setRedirectPath', to.fullPath)
        routeChangeEvent(to, from, routes.login)
        return subdomain && to.meta.isLanding ? next({ name: routes.corporativeLogin }) : next({ name: routes.login })
      }
    } else {
      routeChangeEvent(to, from, routes.login)
      return subdomain && to.meta.isLanding ? next({ name: routes.corporativeLogin }) : next({ name: routes.login })
    }
  }

  if (!to.meta.isPrivate) {
    if (logged) {
      routeChangeEvent(to, from, routes.feed)
      return next({ name: routes.feed })
    } else if (!logged && hasToken) {
      const response = await getUserInfo().catch(e => e.response)
      const success = !isError(response.status)
      if (success) {
        routeChangeEvent(to, from, routes.feed)
        return next({ name: routes.feed })
      } else {
        logoutUser()
        routeChangeEvent(to, from)
        if (subdomain && !store.state.whiteLabel.exists && to.path !== '/' && to.name !== routes.corporativeLogin) removeSubdomainAndRedirect()
        else if (subdomain && (to.path === '/' || to.meta.isLanding)) return next({ name: routes.corporativeLogin })
        else return next()
      }
    } else {
      routeChangeEvent(to, from)
      if (subdomain && !store.state.whiteLabel.exists && to.path !== '/' && to.name !== routes.corporativeLogin) removeSubdomainAndRedirect()
      else if (subdomain && (to.path === '/' || to.meta.isLanding)) return next({ name: routes.corporativeLogin })
      else return next()
    }
  }
}
